import React from 'react';
import useFeatureToggle from 'hooks/useFeatureToggle';
import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import { hasViewMenuItemService } from 'selectors/permissions';
import lazyLoad from 'utils/lazyLoad';
import { getRouterPath } from 'utils/navigation';
import { UnauthorizedPageAccess } from './utils';

const Services = lazyLoad(
  () => import(/* webpackChunkName: "ServicesPage" */ 'pages/Services'),
);

const ServiceDetails = lazyLoad(
  () =>
    import(
      /* webpackChunkName: "ServiceDetails" */ 'pages/Services/ServiceDetails'
    ),
);
const SuggestedServices = lazyLoad(
  () =>
    import(
      /* webpackChunkName: "SuggestedServices" */ 'pages/Services/SuggestedServices'
    ),
);
const ImpactedServiceDependency = lazyLoad(
  () =>
    import(
      /* webpackChunkName: "ImpactedServiceDependency" */ 'pages/Services/ImpactedServiceDependency'
    ),
);

export default function useServicesRoutes() {
  const canViewServices = useSelector(hasViewMenuItemService);
  const isServicesListAndDetailsEnabled = useFeatureToggle(
    'SERVICES_LIST_AND_DETAILS',
  );
  return [
    isServicesListAndDetailsEnabled && (
      <Route
        exact
        path={getRouterPath('/services')}
        component={canViewServices ? Services : UnauthorizedPageAccess}
      />
    ),
    isServicesListAndDetailsEnabled && (
      <Route
        exact
        path={getRouterPath('/services/suggested')}
        component={canViewServices ? SuggestedServices : UnauthorizedPageAccess}
      />
    ),
    isServicesListAndDetailsEnabled && (
      <Route
        path={getRouterPath('/services/:serviceUuid')}
        component={canViewServices ? ServiceDetails : UnauthorizedPageAccess}
      />
    ),
    isServicesListAndDetailsEnabled && (
      <Route
        path={getRouterPath('/incidents/:incidentIdentifier/impacted-services')}
        component={
          canViewServices ? ImpactedServiceDependency : UnauthorizedPageAccess
        }
      />
    ),
  ];
}
